import AxiosAPI from "@src/services/AxiosServices.js";

var APP_URL;

if (process.env.NODE_ENV === 'development')
  APP_URL = "http://localhost:5888"; // DEV
else
  APP_URL = "https://itegateway.com"; // PRODUCT

export const BASE_URL = APP_URL + "/b2c/api";

// ****************************************
// MODULE: 100 - Common - Authentication
// ****************************************
// Check Lagacy Email
// export const reqCheckLegacy = ({
//     username,
//   }) =>
//   AxiosAPI(
//     APP_URL + "/auth/ndenergy/check-legacy", {
//       username
//     },
//     "POST"
//   );

// Register User
export const regPortalUser = ({
    registeruser
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/portal-user-register", {
      registeruser
    },
    "POST"
  );

// User Login
export const reqUserLogin = ({
    username,
    password
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-login", {
      username,
      password
    },
    "POST"
  );

// Change Password
export const regPortalPasswordChange = ({
    loginuser
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/portal-password-change", {
      loginuser
    },
    "POST"
  );

// User Login Refresh
export const reqPortalUserRefresh = ({
    useruuid
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-refresh", {
      useruuid
    },
    "POST"
  );

// Query Portal User Account
export const reqUserAccountList = ({
    useruuid
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-account-list", {
      useruuid
    },
    "POST"
  );

// Register Portal User Account
export const regPortalUserAccount = ({
    registeraccount
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-reg-account", {
      registeraccount
    },
    "POST"
  );

// Get Portal Account Setup
export const reqPortalAccountSetup = ({
    accountuuid,
    portaluser
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-account-setup", {
      accountuuid,
      portaluser
    },
    "POST"
  );


// Reset Login User Password
export const reqPasswordReset = ({
    username,
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-password-reset", {
      username,
    },
    "POST"
  );

// Get Portal Account Setup
export const reqPasswordUpdate = ({
    username,
    useruuid,
    oldpassword,
    newpassword
  }) =>
  AxiosAPI(
    APP_URL + "/auth/ndenergy/user-password-change", {
      username,
      useruuid,
      oldpassword,
      newpassword
    },
    "POST"
  );

// ****************************************
// MODULE: 200 - Metering
// ****************************************
// Get Account Invoice
export const reqAccountMetering = ({
    account
  }) =>
  AxiosAPI(
    BASE_URL + "/metering/req-account-metering", {
      account
    },
    "POST"
  );


// ****************************************
// MODULE: 300 - Billing
// ****************************************
// Get Account Invoice
export const reqAccountInvoice = ({
    account
  }) =>
  AxiosAPI(
    BASE_URL + "/billing/req-account-invoice", {
      account
    },
    "POST"
  );

// Get Account Payment
export const reqAccountPayment = ({
    account
  }) =>
  AxiosAPI(
    BASE_URL + "/billing/req-account-payment", {
      account
    },
    "POST"
  );

// Get Account Balance
export const reqAccountBalance = ({
  account
}) =>
AxiosAPI(
  BASE_URL + "/billing/req-account-balance", {
    account
  },
  "POST"
);

// Get Account Snapshot
export const reqAccountSnapshot = ({
  account
}) =>
AxiosAPI(
  BASE_URL + "/billing/req-account-snapshot", {
    account
  },
  "POST"
);


// ****************************************
// MODULE: 600 - Admin
// ****************************************
// Retrieve Account Profile - Basic
export const reqUserAccountBasic = ({
    account,
  }) =>
  AxiosAPI(
    BASE_URL + "/common/req-account-profile-basic", {
      account
    },
    "POST"
  );

// Retrieve Account Profile - Name
export const reqUserAccountName = ({
    account,
  }) =>
  AxiosAPI(
    BASE_URL + "/common/req-account-profile-name", {
      account
    },
    "POST"
  );